module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department_sp05-20652008d4a7905a7fc17c07e0d3433d.jpg";